import { FC } from 'react';

import type { FlexProps } from 'quarks/interpolations/flex';

import AccordionV1 from 'components/Accordion/AccordionV1';
import AccordionV2 from 'components/Accordion/AccordionV2';

import type { ContentfulComponentAccordion } from 'graphqlTypes';

interface AccordionProps extends FlexProps, ContentfulComponentAccordion {
  backgroundIsDark: boolean;
  accordionHeading?: ContentfulComponentAccordion['heading'];
}

const Accordion: FC<AccordionProps> = ({ sectionStyle, ...props }) => {
  switch (sectionStyle) {
    case 'V2':
      return <AccordionV2 {...props} />;
    default:
      return <AccordionV1 {...props} />;
  }
};

export default Accordion;
